import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Col } from "react-bootstrap";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';


const PopUpWorkPlacesManage = ({ workPlacesData, show, handleClose, onClickButton, data, responsibleOptions }) => {
  const [t] = useTranslation("companies")

  const [error, setError] = useState(false)
  const [name, setName] = useState(data ? data.workplaceName : null)
  const [responsibleId, setResponsibleId] = useState(data ? data.responsibleWorkPlaceId : null)
  const [changedResponsible, setChangedResponsible] = useState(false)
  const [enabledButton, setEnabledButton] = useState(false)

  const handleClick = () => {
    if (name && name.trim().length >= 1) {
      if (validateUniqueName(name)) {
        setError(true);
      } else {
        setError(false);
        onClickButton(data ? data.workplaceId : null, name, responsibleId, changedResponsible);
        handleCloseResetStates();
      }
    } else {
      setError(true);
    }
  };


  const handleChangeName = (value) => {
    setName(value);
    setEnabledButton(true)
  }
  const handleChangeResponsibleId = (value) => {
    setChangedResponsible(true)
    setResponsibleId(value);
    setEnabledButton(true)
  }

  const handleCloseResetStates = () => {
    handleClose();
    setError(false)
    setEnabledButton(false)
  }

  const validateUniqueName = (workplaceName) => {
    if (data) {
      return false
    } else {
      return workPlacesData.some(
        (workplace) =>
          workplace.workplaceName.trim().toUpperCase() === workplaceName.trim().toUpperCase()
      );
    }

  };


  useEffect(() => {
    setName(data ? data.workplaceName : null)
    setResponsibleId(data ? data.responsibleWorkPlaceId : null)
  }, [data]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2">{data ? `${t("workPlacesPopUp.edit")}` : `${t("workPlacesPopUp.create")}`} {t("workPlacesPopUp.workPlace")}</p>
                <div className="text-center mt-auto w-100">
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleCloseResetStates}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <Col md={12}>
                    <FormCard
                      title={t("workPlacesPopUp.name")}
                      text={data ? data.workplaceName : null}
                      type={"text"}
                      error={error}
                      errorMessage={t("workPlacesPopUp.nameError")}
                      readOnly={false}
                      onChange={(e) => {
                        handleChangeName(e.target.value)
                      }}
                      centered
                    />
                  </Col>
                  <Col md={12}>
                    {data && data.responsibleWorkPlaceId ?
                      <FormCard
                        title={t("workPlacesPopUp.responsible")}
                        type={"select"}
                        selectedValue={{
                          label: data.responsibleWorkPlaceFullNameNIF,
                          value: data.responsibleWorkPlaceId,
                        }}
                        options={responsibleOptions}
                        onChange={(e) =>
                          handleChangeResponsibleId(e.value)
                        }
                      />
                      :
                      <FormCard
                        title={t("workPlacesPopUp.responsible")}
                        type={"select"}
                        options={responsibleOptions}
                        onChange={(e) =>
                          handleChangeResponsibleId(e.value)
                        }
                      />
                    }
                  </Col>


                  <Button
                    type="submit"
                    className="w-25 mx-auto mt-4 custom-button-primary custom-bg-primary"
                    onClick={handleClick}
                    disabled={!enabledButton}
                  >
                    {data ? `${t("workPlacesPopUp.save")}` : `${t("workPlacesPopUp.create")}`}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpWorkPlacesManage;